import React from "react";
import { FormProvider } from "react-hook-form";
import { useParams } from "react-router";
import { Button, Form, RequiredFieldsLabel } from "@sscs/ui";
import styles from "./acceptInvite.module.scss";
import useAcceptInviteForm from "./useAcceptInviteForm";

type AcceptInviteForm = {
  onSuccess: () => void;
};

const AcceptInviteForm = ({
  onSuccess,
}: AcceptInviteForm): React.JSX.Element => {
  const { inviteToken = "" } = useParams();

  const { onSubmit, errors, methods } = useAcceptInviteForm(
    onSuccess,
    inviteToken,
  );

  return (
    <FormProvider {...methods}>
      <Form.Form onSubmit={onSubmit}>
        <Form.TextField
          id="accept-invite-first-name"
          label="First name"
          name="firstName"
          autoComplete="given-name"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="accept-invite-last-name"
          label="Last name"
          name="lastName"
          autoComplete="family-name"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="accept-invite-password"
          type="password"
          label="Password"
          name="password"
          autoComplete="new-password"
          isRequired
          errors={errors}
        />
        <Form.TextField
          id="accept-invite-confirm-password"
          type="password"
          label="Confirm password"
          name="confirmPassword"
          autoComplete="new-password"
          isRequired
          errors={errors}
        />
        <RequiredFieldsLabel />
        <div className={styles["create-account-button"]}>
          <Button id="save" type="submit" color="primary" isFullWidth>
            Create account
          </Button>
        </div>
      </Form.Form>
    </FormProvider>
  );
};

export default AcceptInviteForm;
